export interface LoadImageParams {
  image: HTMLImageElement;
  src: string;
  callback?: (image: HTMLImageElement) => void;
  onImageComplete?: () => void;
}

export enum ImageError {
  IMAGE_LOAD_ERROR = 'IMAGE_404_ERROR',
  IMAGE_TIMEOUT_ERROR = 'IMAGE_LOAD_TIMEOUT_ERROR',
}

const IMAGE_LOAD_TIMEOUT_TIME = 7000;
export const loadImage = ({ image, src, callback, onImageComplete }: LoadImageParams): Promise<HTMLImageElement> => {
  return new Promise(function (resolve, reject) {
    const timer = setTimeout(() => {
      reject(new Error(ImageError.IMAGE_TIMEOUT_ERROR));
    }, IMAGE_LOAD_TIMEOUT_TIME);

    image.onload = function () {
      callback?.(image);
      onImageComplete?.();
      clearTimeout(timer);
      resolve(image);
    };

    image.onerror = function () {
      callback?.(image);
      onImageComplete?.();
      clearTimeout(timer);
      reject(new Error(ImageError.IMAGE_LOAD_ERROR));
    };

    image.src = src;
  });
};
